import axios from "axios"

const baseUrl = process.env.VUE_APP_BASE_URL

const phrasedisposals = 
{
    namespaced: true,
    state: {
        phrasedisposals: [],
        phrasedisposal: {}
    },
    mutations: {
        SET_PHRASEDISPOSALS(state, data)
        {
            state.phrasedisposals = data
        },
        SET_ACUTETOX(state, data)
        {
            state.phrasedisposal = data
        }
    },
    actions: {
        getAll ({ commit }) {
          return axios 
          .get(baseUrl+'PhraseDisposal', { withCredentials: true })
          .then(res => {
              console.log(res.data);
              commit('SET_PHRASEDISPOSALS', res.data)
             
          })
          .catch(error => console.log(error))
        },

        deletePhraseDisposal ({ commit }, id) {
            return axios
            .get(baseUrl+'DeleteVendor?vendorId=' + id, { withCredentials: true })
            .catch(error => console.log(error))
          },
          updatePhraseDisposal({ commit }, {id,data}){
            return axios
            .post(baseUrl+'PhraseDisposal/updatePhraseDisposal/'+id, data, { withCredentials: true })
            .then(res => {

                console.log(res)
            })
          },
          
          //This get vendor is used to get a fresh copy from the db to load full details. the getter vendor is used to get current grid vendor
          getPhraseDisposal ({ commit },id) {
            return axios
            .get(baseUrl+'GetVendor?vendorId=' + id, { withCredentials: true })
            .then(res => {
                commit('SET_VENDOR', res.data)
            })
            .catch(error => console.log(error))
        },
        addNewPhraseDisposal ({ commit }, data) {
            return axios
            .post(baseUrl+'PhraseDisposal/addPhraseDisposal', data, { withCredentials: true },)
            .then(res => {
                console.log("new phrase disposal added",res.data)
            })
            .catch(error => console.log(error))
        }
      },
      getters: {}
}

export default phrasedisposals